import React, { useEffect, useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import FeaturesFooter from './FeaturesFooter';
import PersonalPart from './PersonalPart';
import TeamPart from './TeamPart';
import './Pricing.css';
import {
  handleModal,
  switchToTeamTab,
  switchToSelfTab,
  validateEmail,
  validatePassword,
  validateConfirmPassword,
  validateUserCount,
  gotoCheckout
} from '../utils/homeUtils';

const Home = () => {
  const [activeTab, setActiveTab] = useState('teams');

  // Modal state and handlers for TeamPart
  const [showTeamPaidModal, setShowTeamPaidModal] = useState(false);
  const [showTeamContactModal, setShowTeamContactModal] = useState(false);
  const [formData, setFormData] = useState({ email: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      const response = await fetch(process.env.REACT_APP_API_URL+'/api/v1/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ email: formData.email, message: formData.message })
      });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      // Handle new response format
      if (data.status) {
        setSuccess(data.message || 'Message sent successfully!');
        setFormData({ email: '', message: '' });
      } else {
        setError(data.message || 'Failed to send message. Please try again.');
      }
    } catch (err) {
      setError('Failed to send message. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Set copyright year
    const copyrightElement = document.getElementById('copyright');
    if (copyrightElement) {
      copyrightElement.textContent = `© ${new Date().getFullYear()} EWORXS`;
    }

    // Add event listeners for modals
    const modalButtons = {
      'getstart1': 'fee-popup3',
      'getstart2': 'self-paid-popup3',
      'getstart3': 'team-paid-popup3',
      'getstart4': 'contact-popup3'
    };

    Object.entries(modalButtons).forEach(([buttonId, modalId]) => {
      const button = document.getElementById(buttonId);
      const closeButton = document.querySelector(`#${modalId} .close`);
      
      if (button) {
        button.onclick = () => handleModal(modalId, 'open');
      }
      if (closeButton) {
        closeButton.onclick = () => handleModal(modalId, 'close');
      }
    });

    // Add event listeners for tabs
    const teamTab = document.querySelector('.teamtab');
    const selfTab = document.querySelector('.selftab');

    if (teamTab) {
      teamTab.addEventListener('click', switchToTeamTab);
    }
    if (selfTab) {
      selfTab.addEventListener('click', switchToSelfTab);
    }

    // Close modals when clicking outside
    window.onclick = (event) => {
      const modals = ['fee-popup3', 'self-paid-popup3', 'team-paid-popup3', 'contact-popup3'];
      modals.forEach(modalId => {
        const modal = document.getElementById(modalId);
        if (event.target === modal) {
          handleModal(modalId, 'close');
        }
      });
    };

    // Cleanup event listeners
    return () => {
      if (teamTab) {
        teamTab.removeEventListener('click', switchToTeamTab);
      }
      if (selfTab) {
        selfTab.removeEventListener('click', switchToSelfTab);
      }
    };
  }, []);

  return (
    <div className="body">
      <Header />
      <div className="section is--hero" >
        <div className="container-2 is--full">
          <div className="hero">
            <div className="hero__item is--text is--home">
              <div className="hero__content">
                <h1 className="h1" style={{ marginBottom: '12px', fontSize: '42px', fontWeight: 'bold', letterSpacing: 'normal' }}>
                  Fieldworker Software Solutions for the Healthcare Industry
                </h1>
                <div className="text-l">
                  <span className="line-break" style={{ fontSize: '16px', fontWeight: 'normal', lineHeight: '1.38', letterSpacing: 'normal' }}>
                    Have it all! Automated Mileage Tracking, Work Hour Tracking, Document Capturing, Invoicing & much more!<br />
                    User-friendly and versatile for Specialty Pharmacies, Infusion Nurses and the home health industry!
                  </span>
                </div>
                <div>
                  <video controls style={{ width: '100%', height: 'auto', marginTop: '1rem' }}>
                    <source src={`${process.env.REACT_APP_BASE_URL}/videos/introduction_video.mp4`} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <div className="hero__cta" style={{ display: 'none' }}>
                  <a href="#" target="_blank" className="download-button w-inline-block">
                    <img src="img/app-store.svg" loading="lazy" alt="Click to download for iPhone" className="app-store-img" />
                  </a>
                  <a href="#" target="_blank" className="download-button w-inline-block">
                    <img src="img/google-play.svg" loading="lazy" alt="" className="app-store-img" />
                  </a>
                </div>
              </div>
            </div>
            <div className="hero__item is--home-image"></div>
          </div>
        </div>
      </div>

    

      <div className="section is--features" style={{ padding: '20px 0' }}>
        <div id="features" className="anchor-point"></div>
        <div className="container-2" style={{ padding: '0 20px' }}>
          <div className="h4-2 is--indigo is--mobile" style={{ fontWeight: '700', marginBottom: '15px' }}>Features</div>
          
          <div className="features">
            <div className="features__item">
              <div className="features__item-bg is--blue"></div>
              <div className="features__image-container">
                <img src="img/banner5.png" loading="lazy" sizes="(max-width: 767px) 45vw, (max-width: 991px) 26vw, (max-width: 1439px) 22vw, (max-width: 1919px) 19vw, 319.4375px" srcSet="img/banner5-500.png 500w, img/banner5-800.png 800w, img/banner5-1080.png 1080w, img/banner5.png 1212w" alt="" className="features__image" />
              </div>
            </div>
            <div className="features__item is--text">
              <div className="features__text">
                <h2 className="h2-2" style={{ fontSize: '32px' }}>Automated Mileage <br />Tracking</h2>
                <div className="text-l is--dimmed" style={{ marginBottom: '12px' }}>EWORXS automatically tracks mileage. It runs in your phone's background.</div>
                <a href="#pricing" className="button is--indigo w-inline-block" style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '12px 28px',
                  //background: 'linear-gradient(90deg, #4a90e2 0%, #357abd 100%)',
                  background: 'linear-gradient(90deg, #fdd106 0%, #efc504 100%)',

                  color: '#fff',
                  borderRadius: '8px',
                  fontWeight: 700,
                  fontSize: '16px',
                  boxShadow: '0 4px 12px rgba(74,144,226,0.15)',
                  border: 'none',
                  transition: 'all 0.3s',
                  letterSpacing: '0.5px',
                  textDecoration: 'none',
                  marginTop: '12px',
                }}
                  onMouseOver={e => e.currentTarget.style.background = 'linear-gradient(90deg, #357abd 0%, #4a90e2 100%)'}
                  onMouseOut={e => e.currentTarget.style.background = 'linear-gradient(90deg, #4a90e2 0%, #357abd 100%)'}
                >
                  <svg width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '4px'}}>
                    <circle cx="11" cy="11" r="11" fill="#fff" fillOpacity="0.15"/>
                    <path d="M7 11.5l3 3 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <div>Sign up</div>
                </a>
              </div>
            </div>
          </div>

          <div className="features is--rev">
            <div className="features__item">
              <div className="features__item-bg is--yellow"></div>
              <div className="features__image-container">
                <img src="img/banner6.png" loading="lazy" sizes="(max-width: 767px) 45vw, (max-width: 991px) 26vw, (max-width: 1439px) 22vw, (max-width: 1919px) 19vw, 319.4375px" srcSet="img/banner6-500.png 500w, img/banner6-800.png 800w, img/banner6-1080.png 1080w, img/banner6.png 1212w" alt="" className="features__image" />
              </div>
            </div>
            <div className="features__item is--text is--two">
              <div className="features__text">
                <h2 className="h2-2" style={{ fontSize: '32px' }}>Automated Work Hour Tracking</h2>
                <div className="text-l is--dimmed" style={{ marginBottom: '12px' }}>EWORXS easily calculates the number of hours you spend at your client's location.</div>
                <a href="#pricing" className="button is--indigo w-inline-block" style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '12px 28px',
                  //background: 'linear-gradient(90deg, #4a90e2 0%, #357abd 100%)',
                  background: 'linear-gradient(90deg, #fdd106 0%, #efc504 100%)',

                  color: '#fff',
                  borderRadius: '8px',
                  fontWeight: 700,
                  fontSize: '16px',
                  boxShadow: '0 4px 12px rgba(74,144,226,0.15)',
                  border: 'none',
                  transition: 'all 0.3s',
                  letterSpacing: '0.5px',
                  textDecoration: 'none',
                  marginTop: '12px',
                }}
                  onMouseOver={e => e.currentTarget.style.background = 'linear-gradient(90deg, #357abd 0%, #4a90e2 100%)'}
                  onMouseOut={e => e.currentTarget.style.background = 'linear-gradient(90deg, #4a90e2 0%, #357abd 100%)'}
                >
                  <svg width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '4px'}}>
                    <circle cx="11" cy="11" r="11" fill="#fff" fillOpacity="0.15"/>
                    <path d="M7 11.5l3 3 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <div>Sign up</div>
                </a>
              </div>
            </div>
          </div>

          <div className="features">
            <div className="features__item">
              <div className="features__item-bg is--green"></div>
              <div className="features__image-container">
                <img src="img/banner7.png" loading="lazy" sizes="(max-width: 767px) 45vw, (max-width: 991px) 26vw, (max-width: 1439px) 22vw, (max-width: 1919px) 19vw, 319.703125px" srcSet="img/banner7-500.png 500w, img/banner7-800.png 800w, img/banner7-1080.png 1080w, banner7.png 1213w" alt="" className="features__image" />
              </div>
            </div>
            <div className="features__item is--text">
              <div className="features__text">
                <h2 className="h2-2" style={{ fontSize: '32px' }}>Document Capturing</h2>
                <div className="text-l is--dimmed" style={{ marginBottom: '12px' }}>EWORXS has the capability of attaching a document to your completed visit.</div>
                <a href="#pricing" className="button is--indigo w-inline-block" style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '12px 28px',
                  //background: 'linear-gradient(90deg, #4a90e2 0%, #357abd 100%)',
                  background: 'linear-gradient(90deg, #fdd106 0%, #efc504 100%)',

                  color: '#fff',
                  borderRadius: '8px',
                  fontWeight: 700,
                  fontSize: '16px',
                  boxShadow: '0 4px 12px rgba(74,144,226,0.15)',
                  border: 'none',
                  transition: 'all 0.3s',
                  letterSpacing: '0.5px',
                  textDecoration: 'none',
                  marginTop: '12px',
                }}
                  onMouseOver={e => e.currentTarget.style.background = 'linear-gradient(90deg, #357abd 0%, #4a90e2 100%)'}
                  onMouseOut={e => e.currentTarget.style.background = 'linear-gradient(90deg, #4a90e2 0%, #357abd 100%)'}
                >
                  <svg width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '4px'}}>
                    <circle cx="11" cy="11" r="11" fill="#fff" fillOpacity="0.15"/>
                    <path d="M7 11.5l3 3 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <div>Sign up</div>
                </a>
              </div>
            </div>
          </div>

          <div className="features is--rev">
            <div className="features__item">
              <div className="features__item-bg is--yellow"></div>
              <div className="features__image-container">
                <img src="img/banner8.png" loading="lazy" sizes="(max-width: 767px) 45vw, (max-width: 991px) 26vw, (max-width: 1439px) 22vw, (max-width: 1919px) 19vw, 319.4375px" srcSet="img/banner8-500.png 500w, img/banner8-800.png 800w, img/banner8-1080.png 1080w, img/banner8.png 1212w" alt="" className="features__image" />
              </div>
            </div>
            <div className="features__item is--text is--two">
              <div className="features__text">
                <h2 className="h2-2" style={{ fontSize: '32px' }}>Automatically Generates Invoices</h2>
                <div className="text-l is--dimmed" style={{ marginBottom: '12px' }}>EWORXS automatically generates and sends invoices! As easy as that!</div>
                <a href="#pricing" className="button is--indigo w-inline-block" style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '12px 28px',
                  //background: 'linear-gradient(90deg, #4a90e2 0%, #357abd 100%)',
                  background: 'linear-gradient(90deg, #fdd106 0%, #efc504 100%)',

                  color: '#fff',
                  borderRadius: '8px',
                  fontWeight: 700,
                  fontSize: '16px',
                  boxShadow: '0 4px 12px rgba(74,144,226,0.15)',
                  border: 'none',
                  transition: 'all 0.3s',
                  letterSpacing: '0.5px',
                  textDecoration: 'none',
                  marginTop: '12px',
                }}
                  onMouseOver={e => e.currentTarget.style.background = 'linear-gradient(90deg, #357abd 0%, #4a90e2 100%)'}
                  onMouseOut={e => e.currentTarget.style.background = 'linear-gradient(90deg, #4a90e2 0%, #357abd 100%)'}
                >
                  <svg width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '4px'}}>
                    <circle cx="11" cy="11" r="11" fill="#fff" fillOpacity="0.15"/>
                    <path d="M7 11.5l3 3 5-5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <div>Sign up</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="pricing" className="section is--pricing" style={{ padding: '30px 0' }}>
        <div className="container-2" style={{ padding: '0 20px' }}>
          <div className="section-header is--pricing" style={{ marginBottom: '25px' }}>
            <h2 className="h2-2 is--no-paragraph" style={{ marginBottom: '8px' }}>Pricing</h2>
            <h3 className="h2-2 is--no-paragraph">Choose your plan</h3>
          </div>
          <div className="pricing__tabs">
            <div
              className={`pricing__tab is--personal selftab${activeTab === 'self' ? ' tabclassactive' : ''}`}
              onClick={() => setActiveTab('self')}
              style={{ display: 'none' }}
            >
              <div>Self Employed</div>
            </div>
            <div
              className={`pricing__tab is--teams teamtab${activeTab === 'teams' ? ' tabclassactive' : ''}`}
              onClick={() => setActiveTab('teams')}
            >
              <div>Teams</div>
            </div>
          </div>
        </div>
        <div className="container-2 is--pricing" style={{ padding: '0 20px' }}>
          {activeTab === 'self' && <PersonalPart />}
          {activeTab === 'teams' && <TeamPart />}
        </div>
      </div>

      {/* SOS Safety Section */}
      <div style={{ 
        width: '100%', 
        background: 'rgb(78, 1, 89)', 
        padding: '40px 20px',
        boxSizing: 'border-box'
      }}>
        <div style={{ 
          maxWidth: '1200px', 
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center'
        }}>
          <div style={{
            width: '60px',
            height: '60px',
            background: '#fff',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '20px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            flexShrink: 0
          }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              {/* Shield shape */}
              <path d="M12 2L4 5V11C4 16.55 7.16 21.74 12 23C16.84 21.74 20 16.55 20 11V5L12 2Z" fill="none" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              {/* Exclamation mark */}
              <path d="M12 8V12" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="12" cy="15" r="1" fill="#dc2626"/>
            </svg>
          </div>
          <p style={{
            margin: 0,
            fontSize: '17px',
            lineHeight: '1.5',
            fontWeight: '400',
            color: '#fff',
            maxWidth: '100%',
            padding: 0
          }}>
            At EWORXS, safety always comes first. That's why our app includes an SOS feature that's simple, reliable, and built to keep fieldworkers protected wherever the job takes them!
          </p>
        </div>
      </div>

      <FeaturesFooter />
      <Footer />
    </div>
  );
};

export default Home; 
